import type { IdDateRangeParams, DateRangeParams } from '@api/modules/types';

// Params for OData stats queries - alias of common IdDateRangeParams
export type StatsODataParams = IdDateRangeParams;

// Params for all stats queries (no machine id) - alias of common DateRangeParams
export type StatsAllODataParams = DateRangeParams;

export enum STATISTICS_PERIOD {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
  MultipleWeeks = 'MultipleWeeks',
}
export enum STATISTICS_TYPE {
  wholePeriod = 'wholePeriod',
  perPeriod = 'perPeriod',
}
